import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { MenteeListPage } from '../mentee-list/mentee-list'
import { AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GlobalVariable } from '../../global';
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-group-list',
  templateUrl: 'group-list.html',
})
export class GroupListPage {
  menteegroups: any
  usertype: any;
  constructor(public navCtrl: NavController, public alertCtrl: AlertController,
    public navParams: NavParams, private menteeGroupData: MenteeGroupData, private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  ionViewDidLoad() {
    this.getMenteeGroup()
  }

  getMenteeGroup() {
    this.menteeGroupData.getMenteeGroup().subscribe(
      res => {
        this.menteegroups = res['data']
      }, err => {
        this.presentAlert('Error', 'Something went wrong, try again')
      }
    )
  }
  onClickOnView(item) {
    this.navCtrl.push(MenteeListPage, {
      groupid: item.menteegroupid,
      groupname: item.menteegroupname
    })
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/group-list/group-list.ts